import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Constante } from '../../constante';
import { TransaccionApi } from '../models/api/pedido-api';
import { ResponseApi } from '../models/response-api';
import { AppUtil } from '../utility/app-util';

export interface DeliveryServicioApi {
    uuid: string;
    nombre: string;
    productoVarianteId: string;
    sku: string | null;
    isActive: boolean;
}

export interface VarianteServicioApi {
    uuid: string;
    sku: string;
    nombre: string;
}

@Injectable({ providedIn: 'root' })
export class DeliveryServicioService {
    private http = inject(HttpClient);
    private url = AppUtil.addTrailingSlash(environment.URL_API_PEDIDOS) + 'api/delivery-servicio/';

    list(): Observable<DeliveryServicioApi[]> {
        return this.http.get<ResponseApi<DeliveryServicioApi[]>>(this.url + 'list-delivery-servicios').pipe(
            map((res) => (res.success === Constante.REQUEST_STATUS_OK && Array.isArray(res.data) ? res.data : []))
        );
    }

    listVariantes(): Observable<VarianteServicioApi[]> {
        return this.http.get<ResponseApi<VarianteServicioApi[]>>(this.url + 'list-variantes-servicio').pipe(
            map((res) => (res.success === Constante.REQUEST_STATUS_OK && Array.isArray(res.data) ? res.data : []))
        );
    }

    create(body: { nombre: string; productoVarianteId: string }): Observable<TransaccionApi> {
        return this.http.post<ResponseApi<TransaccionApi>>(this.url + 'create-delivery-servicio', body).pipe(
            map((res) => this.requireData(res))
        );
    }

    update(uuid: string, body: { nombre: string; productoVarianteId: string }): Observable<TransaccionApi> {
        return this.http.put<ResponseApi<TransaccionApi>>(this.url + 'update-delivery-servicio/' + uuid, body).pipe(
            map((res) => this.requireData(res))
        );
    }

    delete(uuid: string): Observable<TransaccionApi> {
        return this.http.delete<ResponseApi<TransaccionApi>>(this.url + 'delete-delivery-servicio/' + uuid).pipe(
            map((res) => this.requireData(res))
        );
    }

    private requireData(res: ResponseApi<TransaccionApi>): TransaccionApi {
        if (res.success !== Constante.REQUEST_STATUS_OK || !res.data) {
            const errors = res.errors as { message?: string }[] | null;
            throw new Error(errors?.[0]?.message || res.message || 'Ocurrió un error inesperado.');
        }
        return res.data;
    }
}
